import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'swb-sponsored',
    templateUrl: './sponsored.component.html'
})
export class SponsoredComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
